import React from 'react'
import SimulationIcon from '@mui/icons-material/AutoGraph'
import ButtonDialog from '../shared/ButtonDialog'
import CopyIcon from '@mui/icons-material/ContentCopy'
import axios from 'axios'
import { Form } from '@rjsf/mui'
import { useAuth } from '../../context/useAuth'
import validator from '@rjsf/validator-ajv8'
import { JSONSchema7 } from 'json-schema'

interface Props {
	schema: JSONSchema7
	name: string
	disabled: boolean
	setData: any
}

export default function CopySimulation({ schema, name, disabled, setData }: Props) {
	const [open, setOpen] = React.useState(false)
	const { csrf } = useAuth()

	return (
		<ButtonDialog
			disabled={disabled}
			title={`Copy Simulation`}
			icon={<SimulationIcon />}
			iconButton={<CopyIcon />}
			content={
				<Form
					showErrorList={false}
					transformErrors={(errors: any) => {
						return errors.map((error: any) => {
							if (error.name === 'pattern') error.message = 'Invalid simulation_name'
							return error
						})
					}}
					onSubmit={async (e) => {
						try {
							const res = await axios.post(`${process.env.REACT_APP_API}/${name}/copy`, JSON.stringify(e.formData), {
								headers: {
									'Content-Type': 'application/json',
									'X-CSRFToken': csrf
								},
								withCredentials: true
							})
							setData(res.data)
							setOpen(false)
						} catch (err) {
							console.log('err:', err)
						}
					}}
					validator={validator}
					schema={schema as JSONSchema7}
				/>
			}
			open={open}
			setOpen={setOpen}
		/>
	)
}
